import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyCreateGroupV2 } from 'owa-group-create-integration-v2';
import { getLeftNavGroupsStore } from 'owa-group-left-nav/lib/store/store';
import { lazyLoadGroups } from 'owa-group-left-nav-actions';
import { initializeUserSettings } from 'owa-groups-adaptors';
import { lazyCreateGroup } from 'owa-group-create-integration';
import type { EnterpriseGroup, GroupInfo } from 'owa-groups-discover-integration';
import { lazyGroupsDiscover, UserType } from 'owa-groups-discover-integration';
import { getUnifiedGroupsSettingsStore } from 'owa-groups-shared-store/lib/UnifiedGroupsSettingsStore';
import { getCurrentCulture, getCurrentLanguage } from 'owa-localize';
import { lazySelectGroup } from 'owa-mail-folder-forest-actions';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

function onGroupCreated(groupSmtpAddress?: string) {
    if (groupSmtpAddress) {
        const leftNavGroupsStore = getLeftNavGroupsStore();

        if (!leftNavGroupsStore.myOrgGroups.includes(groupSmtpAddress)) {
            // created group, reload left nav (this will also subscribe to unread)
            lazyLoadGroups.importAndExecute();
        }

        lazySelectGroup.importAndExecute(groupSmtpAddress, 'groups' /* treeType */);
    }
}

export async function openCreateGroup() {
    if (
        isFeatureEnabled('grp-shareable-crud') ||
        getUnifiedGroupsSettingsStore().isSensitivityLabelsEnabled
    ) {
        const createGroup = await lazyCreateGroupV2.import();
        let sessionSettings = getUserConfiguration().SessionSettings;

        if (sessionSettings?.ExternalDirectoryUserGuid) {
            createGroup(
                sessionSettings.ExternalDirectoryUserGuid,
                getCurrentLanguage(),
                getCurrentCulture(),
                'Ribbon',
                onGroupCreated
            );
        }
    } else {
        const createGroup = await lazyCreateGroup.import();
        createGroup(UserType.Enterprise, getCurrentCulture(), 'Ribbon', onGroupCreated);
    }
}

function onGroupsDiscoverClosed(group: GroupInfo | EnterpriseGroup | null) {
    if (group) {
        const groupSmtpAddress = group.smtpAddress.toLowerCase();
        const leftNavGroupsStore = getLeftNavGroupsStore();

        if (!leftNavGroupsStore.myOrgGroups.includes(groupSmtpAddress)) {
            // joined group, reload left nav
            lazyLoadGroups.importAndExecute();
        }

        lazySelectGroup.importAndExecute(groupSmtpAddress, 'groups' /* treeType */);
    }
}

export async function openDiscoverGroups() {
    const discoverGroups = await lazyGroupsDiscover.import();
    const userConfig = getUserConfiguration();
    const userSmtp: string | undefined = userConfig.SessionSettings?.UserEmailAddress;

    if (userSmtp) {
        initializeUserSettings(userSmtp, getCurrentCulture());
        discoverGroups(UserType.Enterprise, getCurrentCulture(), 'Ribbon', onGroupsDiscoverClosed);
    }
}
